<form *ngIf='tourService.bookingForm && tourService.actual_trips_first_available_date'
	id="booking-form"
	autocomplete="off"
	[formGroup]='tourService.bookingForm'>
	<div class="form-wrapper">
		<ng-container *ngIf='tourService.isByParticipantRuleType && !isGroupRole; else group_trip_service_rule_type'>
			<h3 class="inner">{{'Scegli i partecipanti e le date per la tua prenotazione' | translate}}</h3>
		</ng-container>
        <div class="row" *ngIf="tourService.familyEnabled">
            <div class="col-sm-12 col-xs-12 family">
                <input
                        class="form-check-input "
                        type="checkbox" [value]="familyCheck"
                        id="family-check"
                        (change)="familyCheckChange()"
                >
                <label class="form-check-label" for="family-check">
                    {{'Biglietto Famiglia' | translate}}
                </label>
                <span class="sub-tooltip-family">
                    {{ 'family' | translate:{adt:tourService.familyLimitADT.min,chd:tourService.familyLimitCHD.max} }}
                </span>
            </div>

        </div>
		<div class="row">
			<ng-container *ngIf='tourService.isByParticipantRuleType && !isGroupRole'>
				<div [ngClass]='{"col-md-4": tourService.is_first_loading, "col-md-6": !tourService.is_first_loading}' class="col-sm-12 col-xs-12">
					<div class="form-group">
						<label><i class="icon-calendar-7"></i> {{'Partecipanti' | translate}}</label>
						<!-- dropdown -->
						<div class="dropdown">
							<!-- pass -->
							<div id="paxes" class="dropdown-toggle false-input" data-toggle="dropdown">
								<div class="value-input">
									<ng-container *ngFor='let key of added_participant_categories | customKeys; let isLast = last'>
										<span class="partecipants-countes">
											{{added_participant_categories[key].value}} X {{key}}{{isLast ? '' : ', '}}
										</span>
									</ng-container>
								</div>
							</div>
							<!-- dropdown passengers -->
							<div class="row dropdown-menu tickets-popup">
								<ng-container *ngFor='let key of enabled_participant_categories | customKeys'>
									<div class="form-group">
										<div class="select-numbers-left">
											<label class="age_type">{{enabled_participant_categories[key].label}}</label>
											<ng-container *ngIf='enabled_participant_categories[key].age_from && enabled_participant_categories[key].age_to'>
												<small>{{enabled_participant_categories[key].age_from}}-{{enabled_participant_categories[key].age_to}} {{'anni' | translate}}</small>
											</ng-container>
										</div>

										<div class="numbers-row">
											<div class="inc button_inc" (click)='increment(enabled_participant_categories[key])'>
												<span class="bi bi-plus-circle"></span>
											</div>

											<input type="text"
                                                   [id]='enabled_participant_categories[key].formControlName'
                                                   class="qty2 form-control"
                                                   [formControlName]='enabled_participant_categories[key].formControlName'
                                            />
											<div class="dec button_inc" (click)='decrement(enabled_participant_categories[key])'>
												<span class="bi bi-dash-circle"></span>
											</div>
										</div>
									</div>
								</ng-container>
							</div><!-- dropdown -->
						</div>
					</div>
				</div>
			</ng-container>

			<div [ngClass]='{
				"col-md-4": tourService.is_first_loading && tourService.isByParticipantRuleType,
				"col-md-6": !tourService.is_first_loading && tourService.isByParticipantRuleType,
				"col-md-8 custom-width-date-picker": !tourService.isByParticipantRuleType
			}' class="col-sm-12 col-xs-12">
				<label><i class="icon-calendar-7"></i> {{'Seleziona una data' | translate}}</label>
				<div class="date-pick-wrapper">
					<input class="date-pick form-control" readonly='true' data-date-format="dd/mm/yyyy" type="text" formControlName="date" autocomplete="off" />
				</div>
			</div>

			<ng-container *ngIf='tourService.is_first_loading'>
				<div class="col-md-4 col-sm-12 col-xs-12">
					<div class="verify-btn">
						<button type="button" id="verify_availability" (click)='tourService.reload()'>{{'Verifica disponibilità' | translate}}</button>
					</div>
				</div>
			</ng-container>
		</div>
	</div>

	<!-- loader booking preview -->
	<ng-container *ngIf='tourService.recordService.loading.value && !tourService.show_booking_form'>
		<div class="booking-form-before-loading-loader">
			<span class='fa fa-spinner fa-spin spinner'></span>
			<span class='loading-text'>{{'Sto caricando' | translate}}</span>
		</div>
	</ng-container>
	<!-- booking results -->
	<ng-container *ngIf='tourService.show_booking_form'>
		<div [ngClass]="{'results-details-wrapper': true, 'show-results': true, 'loading': tourService.recordService.loading.value}">
			<div class="row booking-detail-box">
				<div class="col-md-12 col-sm-12 col-xs-12">
					<!-- show booking form loading -->
					<ng-container *ngIf='tourService.recordService.loading.value'>
						<div class="booking-form-loading">
							<span class='fa fa-spinner fa-spin'></span>
						</div>
					</ng-container>
					<!-- preview result -->
					<h3 class="title">{{record.description}}</h3>
					<div class="select-actual-trips select-container">
						<!-- actual trips -->
						<ng-container *ngIf='tourService.actualTrips.length && tourService.data?.going_trip'>
							<div class="going_trips">
								<label>{{'Seleziona la partenza' | translate}}</label>
								<div class="select-wrapper">
									<div class="select-options">
										<select class="actual_trip_select" formControlName="actual_trip_id">
											<ng-container *ngFor='let actualTrip of tourService.actualTrips'>
												<option [ngValue]='actualTrip.id'>
													{{actualTrip.display_name + (actualTrip.start_time ? ' (' + actualTrip.start_time + ')': '')}}
												</option>
											</ng-container>
										</select>
									</div>
									<!-- languages -->
									<ng-container *ngIf='tourService.isValid'>
										<div class="actual-trips-flags-container">
											<ng-container *ngFor='let langCode of selectedActualTrip.properties.actual_trip_guide_languages.value'>
												<span class="country-flag">
													<img [src]="'assets/img/flags/' + langCode + '.png'" />
												</span>
											</ng-container>
										</div>
										<!--<div class="guide_languages" *ngIf='tourService.selectedActualTrip'>
											<p class="guides_message" *ngIf='tourService.selectedActualTrip.properties.actual_trip_guide_languages.value.length > 0'>
												Questa esperienza sarà svolta nelle seguenti lingue: <span class="langs">{{tourService.selectedActualTrip.properties.actual_trip_guide_languages.value.join(', ')}}</span>
											</p>
											<p class="audio_guides_message" *ngIf='tourService.selectedActualTrip.properties.actual_trip_audioguide_languages.value.length > 0'>
												È possibile sfruttare audio guide nelle seguenti lingue: <span class="langs">{{tourService.selectedActualTrip.properties.actual_trip_audioguide_languages.value.join(', ')}}</span>
											</p>
										</div>-->
									</ng-container>
								</div>
								<!-- optional resoruces -->
								<div class="optional_services">
									<ng-container *ngIf='tourService.going_resources'>
										<ng-container *ngFor='let optional_resource of tourService.going_resources'>
											<ng-container *ngIf='optional_resource.optional && optional_resource.activable'>
												<label class="resource_name">
													<input type="checkbox" [value]='optional_resource.trip_resource_id' [checked]='optional_resource.activated' (change)='onCheckChange($event, "optional_services")' />
													{{optional_resource.localized_name || 'Optional resource'}} <span class="price">{{optional_resource.total_price_text | currency:'EUR'}}</span>
												</label>

												<ng-container *ngIf='optional_resource.localized_full_description'>
													<div class="description_trip_resource"
														[innerHTML]='optional_resource.localized_full_description'
														[class.display]='optional_resource.activated'
													></div>
												</ng-container>
											</ng-container>
										</ng-container>
									</ng-container>
								</div>
							</div>
						</ng-container>
						<!-- return trips -->
						<ng-container *ngIf='tourService.returnTrips.length && tourService.data?.return_trip'>
							<div class="return_trips">
								<label>{{'Seleziona il ritorno' | translate}}</label>
								<div class="select-wrapper">
									<div class="select-options">
										<select class="actual_trip_select" formControlName="return_trip_id">
											<ng-container *ngFor='let returnTrip of tourService.returnTrips'>
												<option [ngValue]='returnTrip.id'>
													{{returnTrip.display_name + ' (' + returnTrip.start_time + ')'}}
												</option>
											</ng-container>
										</select>
									</div>
								</div>
								<!-- optional resoruces -->
								<div class="optional_services">
									<ng-container *ngIf='tourService.return_resources'>
										<ng-container *ngFor='let optional_resource of tourService.return_resources'>
											<ng-container *ngIf='optional_resource.optional && optional_resource.activable'>
												<label class="resource_name">
													<input type="checkbox" [value]='optional_resource.trip_resource_id' [checked]='optional_resource.activated' (change)='onCheckChange($event, "optional_return_services")' />
													{{optional_resource.localized_name || 'Optional resource'}} <span class="price">{{optional_resource.total_price_text | currency:'EUR'}}</span>
												</label>

												<ng-container *ngIf='optional_resource.localized_full_description'>
													<div class="description_trip_resource"
														[innerHTML]='optional_resource.localized_full_description'
														[class.display]='optional_resource.activated'
													></div>
												</ng-container>
											</ng-container>
										</ng-container>
									</ng-container>
								</div>
							</div>
						</ng-container>
					</div>
				</div>
			</div>
			<!-- FOOTER BOOKING FORM -->
			<ng-container *ngIf='(tourService.hasTripServices || isExternal) && !tourService.no_price_rule; else no_trip_services;'>
				<ng-container *ngIf='tourService.isValid; else availability_error;'>
					<div class="row recap-tour">
						<ng-container *ngIf='cartService.addToCartLoading.value'>
							<div class="addtocart-loader">
								<div class="loader-text">
									<i class="fa fa-shopping-cart"></i>
									{{'Aggiungendo al carrello...' | translate}}
								</div>
								<span class='fa fa-spinner fa-spin spinner'></span>
							</div>
						</ng-container>

						<div class="col-md-5 col-xs-12">
							<div class="list-booking-number age-categories">
								<ng-container *ngIf='tourService.isByParticipantRuleType && !isGroupRole; else limit_pax_per_booking;'>
                                    <div *ngIf="familyCheck">{{'Biglietto famiglia' | translate}}</div>
									<ng-container *ngFor='let key of added_participant_categories | customKeys'>
										<div [class]='added_participant_categories[key].label'>{{added_participant_categories[key].label}} <span [class]='added_participant_categories[key].label + "-number"'>{{added_participant_categories[key].value}}</span></div>
									</ng-container>
								</ng-container>
								<span class="tour-date" *ngIf='tourService.selectedDate.length'>{{tourService.selectedDate | date: 'dd/MM/yyyy'}}</span>
								<span class="tour-time"></span>
							</div>
						</div>

						<div class="col-md-7 col-xs-12">
							<div class="price-addtocart">
								<span *ngIf='tourService.isValid && tourService.discount < 0' class="original-cost">{{tourService.originalPrice | currency:'EUR'}}</span>
								<span *ngIf='tourService.isValid' class="total-cost">{{tourService.price | currency:'EUR'}}</span>
								<button [disabled]='!tourService.isValid' type="button" id="book-now" class="btn_full book-now" (click)='addToCart()'>
									{{'Aggiungi al carrello' | translate}}
								</button>
							</div>
						</div>
					</div>
				</ng-container>
			</ng-container>
		</div>
	</ng-container>
</form>

<!-- handling errors booking preview -->
<ng-container *ngIf='!tourService.isValid && !tourService.recordService.loading.value && !tourService.hasNextAvailableTrip'>
	<ng-container [ngTemplateOutlet]='availability_error'></ng-container>
</ng-container>

<ng-template #availability_error>
	<div class="error">
		<div class="availability_error" id="availability_error">
			{{'Questa opzione non è disponibile. Verifica un punto o una data di partenza alternativa' | translate}}.
		</div>
	</div>
</ng-template>

<!-- non serve -->
<ng-template #no_first_available_date>
	<div class='row no-booking-dates'>
		<div class='col-md-12 no-padding-left-col'>
			<p>
				<strong>{{'Per informazioni, programma completo e prenotazioni' | translate}}:</strong>
				<br>
				<a href="mailto:sanpellegrino@zaniviaggi.it" target="_blank" rel="noopener noreferrer">sanpellegrino@zaniviaggi.it&nbsp;</a>
				<br>
				<a href="tel:034522160">{{'tel' | translate}}: 0345 22160</a><br><a href="mailto:agenzia@zaniviaggi.it" target="_blank" rel="noopener noreferrer">agenzia@zaniviaggi.it</a>
			</p>
		</div>
	</div>
</ng-template>

<ng-template #no_trip_services>
	<div class="error">
		<div class="no_trip_services">{{'Nessun prezzo per categoria di età configurato' | translate}}.</div>
	</div>
</ng-template>

<ng-template #group_trip_service_rule_type>
	<h3 class="inner">{{'Scegli la data per la tua prenotazione' | translate}}</h3>
</ng-template>

<ng-template #limit_pax_per_booking>
	<div>Numero partecipanti consentiti per gruppo: {{ tourService.limit_pax_per_booking }}</div>
</ng-template>
